import React from "react";
import {useTranslation} from "react-i18next";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";

import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {SelectField} from "./FilterComponentStyles";

const EquipmentTypeFilter = ({
    value,
    onChange,
    disabled = true,
    initialCall = true,
    mode = undefined,
    showAllOption = true,
    allowClear = false,
    hideTitle = false,
    updateStoreOptions = true,
    marginBottom = "0"
}) => {
    const {t} = useTranslation([]);
    const stores = useStore();

    const [equipmentTypesLoading, equipmentTypes] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.equipmentStore.listEquipmentTypes.bind(null, {}),
        dependencies: [],
        initialCall: initialCall,
        callbackFunc: response => {
            if (updateStoreOptions) {
                const items = response?.data?.result || [];
                stores.equipmentStore.setEquipmentTypes(items);
            }
        }
    });

    return (
        <React.Fragment>
            {!hideTitle ? <h5>{"Ekipman Tipi"}</h5> : <></>}
            <SelectField
                loading={equipmentTypesLoading || stores.equipmentStore.equipmentTypes.length === 0}
                data-testid="equipmentTypeSelect"
                value={value}
                onChange={onChange}
                disabled={disabled && equipmentTypesLoading}
                mode={mode}
                filterOption={(input, option) =>
                    option?.props?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0 ||
                    option?.props?.value?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
                }
                allowClear={allowClear}
                mb={marginBottom}
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {arrayAlphabeticalSort([...stores.equipmentStore.equipmentTypes], "name").map(
                    equipmentType => (
                        <SelectField.Option
                            key={equipmentType._id}
                            value={equipmentType._id}
                            data-testid="equipmentTypeSelect_option"
                        >
                            {equipmentType?.name}
                        </SelectField.Option>
                    )
                )}
            </SelectField>
        </React.Fragment>
    );
};

export default EquipmentTypeFilter;
